import { BaseSchema } from "./BaseSchema";
import dayjs from "dayjs";
import { SLUG_LIST } from "utilities/constants";
export class PostSchema extends BaseSchema {
    constructor(entry) {
        super();
        const webPage = this.webPage(entry);
        this.schema.push(webPage);
        this.schema.push(this.BreadcrumbList(entry));
        this.schema.push(this.NewsArticle(entry));
    }

    BreadcrumbList(entry) {
        const schemas = {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": []
        };
        schemas.itemListElement.push({
            "@type": "ListItem",
            "position": 1,
            "item": {
                "id": "https://happynest.vn/",
                "@type": "Thing",
                "name": "Happynest",
                "url": "https://happynest.vn/"
            }
        });
        if (typeof entry.all_terms != 'undefined') {
            const term_slug = entry.all_terms.data.filter(x => {
                return x.slug == 'kho-anh' || SLUG_LIST.some(SLG => SLG.slug.toLocaleLowerCase() === x.slug.toLocaleLowerCase())
            });
            for (const [key, item] of Object.entries(term_slug)) {
                const slug = item.slug === 'kho-anh' ? 'album' : item.slug;
                const url = `https://happynest.vn/${slug.toLocaleLowerCase()}`;
                schemas.itemListElement.push({
                    "@type": "ListItem",
                    "position": 2 + parseInt(key),
                    "item": {
                        "id": url,
                        "@type": "Thing",
                        "name": item.name,
                        "url": url
                    }
                });
            }
            schemas.itemListElement.push({
                "@type": "ListItem",
                "position": term_slug.length + 2,
                "item": {
                    "@type": "Thing",
                    "name": entry.title,
                    "url": entry.show_url
                }
            });
        }

        return schemas;
    }

    NewsArticle(entry) {
        const data = {
            "@context": "https://schema.org/", "@type": "NewsArticle",
        };
        const organization = this.organization();
        delete organization["@context"];
        const webPage = this.webPage(entry);
        delete webPage["@context"];
        if (typeof entry.seo != "undefined") {
            data["@id"] = entry.show_url;
            data['name'] = entry.title;
            data["headline"] = entry.seo.title;
            data["description"] = entry.seo.description;
            data["thumbnailUrl"] = entry.storage_thumbnail_url;
            data["author"] = {
                "@type": "Person",
                "name": entry?.user?.fullname,
                "description": entry.user?.bio,
                "url": entry.user?.wall_url,
                "image": {
                    "@type": "ImageObject",
                    "@id": entry.avatar + '#image',
                    "url": entry.avatar,
                    "caption": entry.user?.full_name,
                    "inLanguage": "vi"
                }
            };
            data["publisher"] = organization;
            data["datePublished"] = dayjs(entry.created_at, "Y-m-d\\TH:i:s");
            data["dateModified"] = dayjs(entry.updated_at, "Y-m-d\\TH:i:s");
            data["keywords"] = (entry.seo.keywords === "" || entry.seo.keywords == null) ? "" : entry.seo.keywords.split(", ");
            data["mainEntityOfPage"] = webPage;
            data["inLanguage"] = "vi";
            data["isPartOf"] = {
                "@id": entry.show_url
            };
        }
        if (typeof entry.images != "undefined" && entry.images.data.length > 0) {
            data["image"] = [];
            for (const [key, item] of Object.entries(entry.images.data)) {
                data["image"].push(item.storage_url);
            }
        }
        return data;
    }

    webPage(entry) {
        const data = {
            "@context": "https://schema.org/",
            "@type": "WebPage",
        };
        if (typeof entry.seo != "undefined") {
            data["name"] = entry.seo.title;
            data["description"] = entry.seo.description;
            data['url'] = entry.show_url;
            data["datePublished"] = dayjs(entry.created_at, "Y-m-d\\TH:i:s");
            data["dateModified"] = dayjs(entry.updated_at, "Y-m-d\\TH:i:s");
            data["isPartOf"] = {
                "@type": "WebSite",
                "url": "https://happynest.vn/",
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": { "@type": "EntryPoint", "urlTemplate": "https://happynest.vn/tim-kiem?keyword={keyword}" },
                    "query-input": {
                        "@type": "PropertyValueSpecification",
                        "valueRequired": "http://schema.org/True",
                        "valueName": "keyword"
                    }
                }
            };
            data["primaryImageOfPage"] = {
                "@type": "ImageObject",
                "@id": entry.storage_thumbnail_url + '/#imageObject',
                "url": entry.storage_thumbnail_url,
                "width": "800",
                "height": "400",
                "caption": entry.title,
                "inLanguage": "vi"
            };
            data["inLanguage"] = "vi";
        }
        return data;
    }
}